import { urls } from "../../shared/seo/links";

export function magazineUrl(lang) {
  return urls.sectionPath("blogs", lang);
}

// /<magazine>/<title-slug>/<id>, in the article's own language; `lang` is
// only the fallback for articles without one.
export function articleUrl(blog, lang) {
  return urls.blogPath(blog, urls.blogLang(blog, lang));
}

// Prefer the short description; otherwise the body as plain text.
export function articleExcerpt(blog, length = 170) {
  const text = blog.description || (blog.body || "").replace(/<[^>]*>/g, " ");
  const clean = text.replace(/\s+/g, " ").trim();
  return clean.length > length ? clean.slice(0, length).trim() + "…" : clean;
}

export function formatArticleDate(date, lang) {
  if (!date) return "";
  const locale = lang === "ar" ? "ar-TN" : lang === "fr" ? "fr-FR" : "en-GB";
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(date));
}
